module.exports = __webpack_public_path__ + "static/media/sena_logo.6de6c6c4.png";